enum ROUTES {
  ERROR = 'ERROR',
  // AUTH ROUTE ENTRY
  AUTH_LOGIN = 'AUTH_LOGIN',
  // MAIN ROUTE ENTRY
  MAIN_DRAFTS = 'MAIN_DRAFTS',
  MAIN_VOUCHERS = 'MAIN_VOUCHERS',
  MAIN_USERS = 'MAIN_USERS',
  MAIN_AGENT_APPLICATIONS = 'MAIN_AGENT_APPLICATIONS',
  MAIN_LISTINGS = 'MAIN_LISTINGS',
  MAIN_DASHBOARD = 'MAIN_DASHBOARD',
  MAIN_CHARITIES = 'MAIN_CHARITIES',
  MAIN_BROKERS = 'MAIN_BROKERS',
  MAIN_EMAIL_MARKETING = 'MAIN_EMAIL_MARKETING',
  QUICK_LISTING = 'QUICK_LISTING',
  CREATE_TEMPLATE = 'CREATE_TEMPLATE',
}

export const routesSettings = Object.freeze({
  // AUTH ROUTE SETTINGS ENTRY
  [ROUTES.AUTH_LOGIN]: {
    name: 'Login',
    path: '/',
    getPath: () => `/`,
  },
  // MAIN ROUTE SETTINGS ENTRY
  [ROUTES.MAIN_DRAFTS]: {
    name: 'Drafts',
    path: '/drafts',
    getPath: () => `drafts`,
  },
  [ROUTES.MAIN_VOUCHERS]: {
    name: 'Vouchers',
    path: '/vouchers',
    getPath: () => `/vouchers`,
  },
  [ROUTES.MAIN_USERS]: {
    name: 'Users',
    path: '/users',
    getPath: () => `/users`,
  },
  [ROUTES.MAIN_LISTINGS]: {
    name: 'Listings',
    path: '/listings',
    getPath: () => `/listings`,
  },
  [ROUTES.MAIN_AGENT_APPLICATIONS]: {
    name: 'AgentApplications',
    path: '/agent-applications',
    getPath: () => `/agent-applications`,
  },
  [ROUTES.MAIN_CHARITIES]: {
    name: 'Charities',
    path: '/charities',
    getPath: () => '/charities',
  },
  [ROUTES.MAIN_BROKERS]: {
    name: 'Brokers',
    path: '/brokers',
    getPath: () => '/brokers',
  },
  [ROUTES.MAIN_EMAIL_MARKETING]: {
    name: 'EmailMarketing',
    path: '/email-marketing',
    getPath: () => '/email-marketing',
  },
  [ROUTES.CREATE_TEMPLATE]: {
    name: 'EmailMarketingCreate',
    path: '/email-marketing-create-template',
    getPath: () => '/email-marketing-create-template',
  },
  [ROUTES.QUICK_LISTING]: {
    name: 'QuickListing',
    path: '/quick-listing',
    getPath: () => '/quick-listing',
  },
});

export default ROUTES;
